/* eslint-disable */
import { CheckCircleIcon, InformationCircleIcon, XCircleIcon } from "@heroicons/react/outline";
import { useCallback, useMemo, useRef } from "react";
import { CSSTransition } from "react-transition-group";
import PropTypes from "prop-types";
import { Toast } from "react-bootstrap";
import { isString } from "lodash";
import { useState } from "react";
import { useEffect } from "react";

const dismissDelay = 5000;
const iconClasses = "i i-2x me-2";

function decodeHtml(html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}

const NotificationToast = ({
	onClose,
	notification
}) => {
	const nodeRef = useRef(null);
	const [show, setShow] = useState(false);

	const handleHide = useCallback(() => {
		setShow(false);
	}, []);

	const handleExited = useCallback(() => onClose(notification.id), [notification]);

	useEffect(() => setShow(true), []);

	const toastIcon = useMemo(() => {
		if (notification.icon) {
			return notification.icon;
		}

		const toastType = notification.type || "info";

		switch (toastType) {
		case "success":
			return <CheckCircleIcon className={iconClasses} />;
		case "danger":
			return <XCircleIcon className={iconClasses} />;
		default:
			return <InformationCircleIcon className={iconClasses} />;
		}
	}, [notification.icon, notification.type]);

	const toastContent = useMemo(() => {
		let message = notification?.header || notification?.message || notification?.body || '';
		if (isString(notification)) {
			message = notification;
		}
		return decodeHtml(message);
	}, [notification]);

	return (
		<CSSTransition
			classNames="notification-toast"
			in={show}
			nodeRef={nodeRef}
			onExited={handleExited}
			timeout={300}
			unmountOnExit
		>
			<Toast
				autohide
				bg={notification.type || "info"}
				className={`rounded-2 ${notification.className || ""}`}
				delay={dismissDelay}
				onClose={handleHide}
				ref={nodeRef}
			>
				<Toast.Header className={`justify-content-between rounded-2 ${notification.className}`}><span>{toastIcon}<span dangerouslySetInnerHTML={{ __html: toastContent }} /></span></Toast.Header>
			</Toast>
		</CSSTransition>
	);
};

NotificationToast.propTypes = {
	notification: PropTypes.shape({
		body: PropTypes.element,
		className: PropTypes.string,
		icon: PropTypes.element,
		header: PropTypes.string,
		id: PropTypes.string,
		message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
		type: PropTypes.string
	}).isRequired,
	onClose: PropTypes.func.isRequired
};

export default NotificationToast;
